import { IAnalytic } from '../../../../types/analytics';

interface ListNavigationProps {
  availableAnalytics: IAnalytic[];
  activePlotAnalytics: string | null;
  handleAnalyticsTypeChanged: (analytic: IAnalytic) => void;
}

const ListNavigation = ({
  availableAnalytics,
  activePlotAnalytics,
  handleAnalyticsTypeChanged,
}: ListNavigationProps) => {
  const handleClick = (item: IAnalytic) => {
    handleAnalyticsTypeChanged(item);
  };

  const getItemStyles = (item: IAnalytic) => {
    const isActive = item.id === activePlotAnalytics;

    return {
      container: {
        padding: '12px 8px',
        transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
        borderRadius: '6px',
        margin: '2px 0',
        cursor: 'pointer',
        color: item.disabled ? 'grey' : '#0099ff',
        fontWeight: isActive ? 'bold' : 'normal',
        backgroundColor: isActive ? 'rgba(0, 153, 255, 0.1)' : 'transparent',
        borderRight: isActive ? '3px solid #0099ff' : 'none',
        transform: isActive ? 'translateX(2px)' : 'none',
        opacity: item.disabled ? 0.6 : 1,
      },
      text: {
        fontSize: '13px',
        display: 'block',
        lineHeight: '1.3',
        color: item.disabled ? 'grey' : 'inherit',
        fontWeight: isActive ? 600 : 'normal',
      },
    };
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', fontSize: '12px' }}>
      {availableAnalytics.map((item) => {
        const styles = getItemStyles(item);
        const id = item.id.replace(/\s+/g, '');

        return (
          <div
            role='button'
            key={id}
            id={`Analytics-${id}-Navigation_Button`}
            data-testid={`Analytics-${id}-Navigation_Button`}
            style={styles.container}
            onClick={() => handleClick(item)}
          >
            <span style={styles.text}>{item.name}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ListNavigation;
